export const GET_NAVIGATION = 'GET_NAVIGATION'
